<template>
  <div class="pay_list">
    <dl>
      <dt>订单编号：{{businessId}}</dt>
      <dd>
        <img v-if="params.faceUri" :src="params.faceUri" class="list_img" />
        <img v-if="!params.faceUri || params.faceUri==''" src="@/assets/images/test_img.jpg" class="list_img" />
        <h3>{{params.title}}</h3>
        <p class="price_a">金额 ¥<span>{{parseFloat(params.point).toFixed(2)}}</span>元</p>
      </dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'coursePayInfo',
  props: ['businessID', 'productID'],
  data () {
    return {
      productId: this.productID,
      businessId: this.businessID,
      params: {}
    }
  },
  created () {
    this.getExamPaper(this.productId)
  },
  methods: {
    getExamPaper (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/searchByUser', {id: id}, r => {
        if (r.data) {
          this.params = r.data[0]
          this.result = {
            money: this.params.point,
            subject: this.params.title
          }
          this.$emit('success', this.result)
        }
      })
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/modules/exam/pay_info.vue